import { Entity } from "@thewebops/admin-panel";

export default (authConfig) =>
  new Entity({
    title: `Complete your ${authConfig.displayName} profile`,
    subTitle: `Enter the credentials associated with your ${authConfig.displayName} account.`,
    path: "/completeProfile/:token",
    submitButtonText: "Complete my profile",
    action: "create",
    fields: [
      {
        label: "New Password",
        required: true,
        type: "password",
        identifier: "password",
      },
      {
        label: "Confirm new Password",
        required: true,
        type: "password",
        identifier: "password_confirmation",
      },
      {
        label: "Image",
        required: true,
        type: "image",
        identifier: "image_url",
      },
    ],
    requestConfig: {
      url: `/${authConfig.serverName}/confirmations`,
      method: "put",
      successMessage: "Profile completed",
      errorMessage: "Couldn't complete profile",
      payloadWrapper: {
        name: "admin",
        fields: ["password", "password_confirmation"],
      },
      successRedirectPath: "/login",
      useFormData: true,
    },
    queryParamName: "confirmation_token",
  });
